<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["PV"][obj_asm.I > 0? "EPVA": "APVA"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["PV"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        v-model="obj_asm['AGIT']"
                                                        @input="AgentGroupChange"
                                                        :disabled="obj_asm.I > 0"
                                                        ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["PV"]["DN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_do"
                                                        :placeholder="this.utilGetDDLanguage('PV.DN')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        @input="DomainChange"
                                                        v-model="obj_asm['DIT']"
                                                        :disabled="obj_asm.I > 0"
                                                        ref="DIT">
                                                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }">
                                                    {{ node.label }} <i v-if="node.id.endsWith('-0')" class='fa-solid fa-globe text-info ml-1'></i>
                                                </label>
                                            </treeselect>
                                            <span class="ErrMsg">{{ ValidationErrMsg('DIT','DN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage["BN"]["L"]}}:</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_lang"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :defaultExpandLevel="Infinity"
                                                        :placeholder="this.utilGetDDLanguage('BN.L')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        v-model="obj_asm['Lang']"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        ref="Lang">
                                            </treeselect>
                                           <!--<span class="ErrMsg">{{ ValidationErrMsg('Lang','L') }}</span>-->
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["PV"]["VT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_qrt"
                                                        :placeholder="this.utilGetDDLanguage('PV.VT')"
                                                        v-model="obj_asm['VT']"
                                                        ref="VT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('VT','VT') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="d-flex ">
                                            <div style="margin-bottom:20px;margin-right:20px;">
                                                <label class="col-form-label-sm">{{getLanguage["PV"]["S"]}} :</label><br>
                                                <label class="switch">
                                                    <input type="checkbox" :checked="bool_obj_PvS" @change="v => bool_obj_PvS = v.target.checked">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>

                                            <div style="margin-bottom:20px;margin-right:20px;"  v-if="bool_obj_PvS">
                                                <label class="col-form-label-sm">{{getLanguage["PV"]["DBL"]}} :</label><br>
                                                <label class="switch">
                                                    <input type="checkbox" :checked="bool_obj_PvDBL" @change="v => bool_obj_PvDBL = v.target.checked">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>

                                            <div style="margin-bottom:20px;margin-right:20px;"  v-if="bool_obj_PvS">
                                                <label class="col-form-label-sm">{{getLanguage["PV"]["DAL"]}} :</label><br>
                                                <label class="switch">
                                                    <input type="checkbox" :checked="bool_obj_PvDAL" @change="v => bool_obj_PvDAL = v.target.checked">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </CCol>

                                        <CCol col="6" v-if="obj_asm.VT == '0' || obj_asm.VT == '1' || obj_asm.VT == '2'">
                                            <label class="col-form-label-sm">{{this.getLanguage["PV"]["C"]}}<span class="required" /> :</label>
                                            <textarea vertical="" rows="6" class="form-control form-control-sm" v-model="obj_asm.C" v-shortkey.avoid ref="C" />

                                            <span class="ErrMsg">{{ ValidationErrMsg('C','C') }}</span>
                                        </CCol>

                                        <CCol col="12" v-if="obj_asm.VT == '3'">
                                            <label class="col-form-label-sm">{{this.getLanguage["PV"]["C"]}}<span class="required" /> :</label>
                                            <editor id="htmluuid" @onChange="HTMLEditorTextChange" :value="obj_asm.C" :init="init" ref="C" />

                                            <span class="ErrMsg">{{ ValidationErrMsg('C','C') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" v-if="checkModuleAccess2(constAccessType.add)" @click="savePV()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["PV"]["PV"]}}</h2>
                        <CButton v-if="checkModuleAccess2(constAccessType.add)" size="sm" color="outline-info" @click="addPV()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PV"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{getLanguage["PV"]["S"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="arry_status"
                                            :placeholder="this.utilGetDDLanguage('PV.S')"
                                            v-model="str_FV[3].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[4].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[4].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[4].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[4].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[4].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[4].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PV"]["DN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('PV.DN')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[1].FV">
                                    <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }">
                                        {{ node.label }} <i v-if="node.id.endsWith('-0')" class='fa-solid fa-globe text-info ml-1'></i>
                                    </label>
                                </treeselect>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PV"]["VT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_qrt"
                                            :placeholder="this.utilGetDDLanguage('PV.VT')"
                                            v-model="str_FV[2].FV">
                                </treeselect>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{getLanguage["BN"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_langfs"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('BN.L')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[5].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`"></treeselect>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["PV"]["PVL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["PV"]["S"]}} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["PV"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["PV"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["PV"]["C"]}}</th>
                                <th>{{this.getLanguage["PV"]["VT"]}}<i @click="setSortTable('VT')" :class="setSortLogo('VT')" class="sortlogo"></i></th>
                                <th>{{getLanguage["BN"]["L"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["PV"]["S"]}} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["PV"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["PV"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["PV"]["C"]}}</th>
                                <th>{{this.getLanguage["PV"]["VT"]}}<i @click="setSortTable('VT')" :class="setSortLogo('VT')" class="sortlogo"></i></th>
                                <th>{{getLanguage["BN"]["L"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(data,index) in arry_sml">
                                <td>{{ CountItem(index+1) }}</td>
                                <td colspan="100%" v-if=" arry_sml.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                    <span id="actionBtnCol">
                                        <div v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                            <i class="cil-trash" @click="removePV(data)"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                            <i class="cil-trash"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                            <i class="cil-color-border" @click="editPV(data.I)"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                            <i class="cil-color-border"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                    </span>
                                </td>
                                <td>
                                    <span :style="`color:${data.RS == '2' ? 'green':'red' }`">{{ renderStatus(data.RS)}}</span>
                                </td>
                                <td>{{data.GN}} ({{data.PC}})</td>
                                <td><span class="grid-line" v-for="domain in data.Domains">{{ domain.label }} <i v-if="domain.id.endsWith('-0')" class='fa-solid fa-globe text-info ml-1'></i></span></td>
                                <td>{{ substrContent(data.C,40) }}</td>
                                <td>{{getVideoType(data.VT)}}</td>
                                <td><span class="grid-line" v-for="lang in data.Languages">{{ lang }}</span></td>
                                <td>{{ data.CB }}</td>
                                <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                <td>{{ data.UB }}</td>
                                <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required, url } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, constStatus, constImgURClientId, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import Editor from '@tinymce/tinymce-vue'
    import Axios from 'axios';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    function validateUrl(value, vm) {
        if (vm.VT == 0 || vm.VT == 1 || vm.VT == 2) {
            var pattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
            return pattern.test(this.obj_asm.C);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            'editor': Editor
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [
                    { F: "AGI" }, //0
                    { F: "DIT" }, //1
                    { F: "VT" }, //2
                    { F: "RS" }, //3
                    {
                        F: "CTS", FV: {  //4
                            startDate: "",
                            endDate: ""
                        }
                    },
                    { F: "L_csv", FA: true } //5
                ], //Filter Value
                arry_sml: [], //social media list
                obj_asm: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    //DN: null,
                    DI: null,
                    DAI: null,
                    DIT: null,
                    AGI: "",
                    AGIT: null,
                    Lang: null,
                    VT: null,
                    C: null,
                    DBL: 1,
                    DAL: 1,
                    L: null,
                }, // add PV
                bool_obj_PvS: true,
                bool_obj_PvDBL: true,
                bool_obj_PvDAL: true,
                arry_status: [],
                dd_qrt: [
                    { id: '0', label: 'Youtube' },
                    { id: '1', label: 'MP4' },
                    { id: '3', label: 'HTML Editor' },
                    //{ id: '2', label: 'Iframe' },
                ],//video type
                dd_do: [], // Domain Option
                dd_dofs: [], // Domain Option for search
                dd_lang: [],//language option
                dd_langfs: [], //language option
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_neto: [], // Network Option
                constAccessType: constAccessType,
                editorText: "",
                init: {
                    height: 500,
                    plugins: [
                        'lists advlist',
                        'image imagetools',
                        'link autolink',
                        'table',
                        'charmap',
                        'searchreplace visualblocks code fullscreen',
                        'print preview anchor insertdatetime',
                        'help codesample hr pagebreak nonbreaking toc textpattern noneditable',
                        'importcss',
                        'directionality',
                        'visualchars',
                        'emoticons',
                        'autosave',
                        'wordcount'
                    ],
                    toolbar:
                        'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                    branding: false,
                    menubar: true,
                    file_picker_callback: function (cb) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            this.bool_fullLoading = true;
                            var file = this.files[0];
                            var reader = new FileReader();

                            if (!file) {
                                return;
                            }
                            if (!file.name.match(/\.(jpg|jpeg|png)$/)) {
                                return;
                            }

                            reader.onload = function () {
                                var that = this;
                                var formData = new FormData();
                                formData.append('image', file)

                                Axios({
                                    url: 'https://api.imgur.com/3/image',
                                    method: 'POST',
                                    headers: {
                                        'Authorization': 'Client-ID ' + constImgURClientId
                                    },
                                    data: formData
                                })
                                    .then((result) => {
                                        let url = result.data.data.link;
                                        that.bool_fullLoading = true;
                                        cb(url, { title: file.name });
                                    })
                                    .catch((err) => {
                                        that.bool_fullLoading = true;
                                        console.log(err);
                                    });
                            };
                            reader.readAsDataURL(file);
                        };
                        input.click();
                    }
                }
            }
        },
        validations: {
            obj_asm: {
                AGIT: { required },
                //DN: { required },
                DIT: { required },
                VT: { required },
                C: { required, validateUrl },
                //Lang: { required }
            },

        },
        created() {
            this.$parent.showSubMenu = 'CMS';
            this.$parent.showActiveMenu = 'CMS.PV';
            if (this.$route.path == '/WEBS/PV') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showSubSubMenu = 'CMS1';
                this.$parent.showActiveMenu = 'WEBS.PV';
            }
            this.getStatus();
            this.getPVList();
            this.getAgentGroup();
            this.getLanguageFilter();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            DomainChange(value) {
                if (Array.isArray(value)) {
                    value = value[0];
                }
                var that = this;
                //Detect if includes '-' for Alternate Domain ID
                if (typeof value === 'string' && value.includes("-")) {
                    value = value.split("-")[0]; // Extract the first part (Domain ID) after splitting
                    value = parseInt(value);
                }

                if (value && value > 0) {
                    //var valueLst = value.split("-");
                    //var dd = "";
                    //if (valueLst.length > 0) {
                    //    dd = valueLst[0];
                    //} else {
                    //    dd = value;
                    //}

                    this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
                        if (s) {
                            that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });
                }
                else {
                    that.dd_lang = [];
                }
                if (that.obj_asm.I == 0)
                    that.obj_asm.Lang = [];
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[4].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[4].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[4].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[4].FV.endDate = "";
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "C") {
                    this.obj_asm.C = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('PV', 'CMS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPVList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getPVList();
                }
            },
            getStatus() {
                this.arry_status = [{ id: '1', label: this.getLanguage['GL']['DISB'] }, { id: '2', label: this.getLanguage['GL']['ENB'] }];
            },
            renderStatus(index) {
                return this.arry_status[index - 1].label;
            },
            ConvertVideoTypeType(value) {
                if (this.dd_neto) {
                    for (var i = 0; i < this.dd_neto.length; i++) {
                        if (this.dd_neto[i].id == value) {
                            return this.dd_neto[i].label
                        }
                    }
                }
            },

            getVideoType(type) {
                var result = "";
                try {
                    result = this.dd_qrt.filter(obj => { return obj.id === type.toString() })[0].label
                    //result = this.dd_qrt[type]["label"];
                }
                catch (ex) {
                    //console.log(ex);
                }
                return result;
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dadn2/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[0].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV[0].FV = null;
                }
            },
            AgentGroupChange(value) {
                if (this.obj_asm['I'] == 0) {
                    this.obj_asm['DIT'] = null;
                }
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                }

                this.getDataApi(`/api/dd/dadn2/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_do = d.dropdownlist
                        }
                    });
            },
            getPVList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else if (this.str_FV[i].F == 'DIT') {
                            //var domain = this.str_FV[i].FV.split("-");
                            //path += "&f[DI]=" + domain[0] + "&f[DAI]=" + domain[1];
                            path += "&f[DL_csv]=" + this.str_FV[i].FV;
                        }

                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }

                };
                this.getDataApi(`/api/cms/pv/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setPVList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setPVList(data) {
                this.arry_sml = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;

            },
            setPV(data) {
                this.obj_asm = Object.assign(this.obj_asm, data);
                var arry_splitLang = this.obj_asm["L"].split(",");
                this.obj_asm["Lang"] = arry_splitLang;
                //this.obj_asm.DIT = this.obj_asm.DI + "-" + this.obj_asm.DAI;
                this.bool_isAMV = true;
                this.editorText = data.C;
                this.bool_obj_PvS = this.defineStatus();
                this.bool_obj_PvDBL = this.returnDisplayBeforeLoginStatus();
                this.bool_obj_PvDAL = this.returnDisplayAfterLoginStatus();


                if (this.obj_asm.AGI != 18) {
                    //console.log(value)
                    this.obj_asm.AGIT = "3-" + this.obj_asm.AGI;
                    this.AgentGroupChange(this.obj_asm.AGIT);
                }
                else if (this.obj_asm.AGI == 18) {
                    //console.log(value)
                    this.obj_asm.AGIT = "0-" + this.obj_asm.AGI;
                    this.obj_asm.AT = 0;
                    this.AgentGroupChange(this.obj_asm.AT);

                    if (this.obj_asm['SBEAGI']) {
                        //console.log(value)
                        this.excludeAGI = this.obj_asm['SBEAGI'].split(",");
                        this.excludeAGI = this.excludeAGI.map(function (i) {
                            return "3-" + i;
                        });
                    }
                }

                if (this.obj_asm.Lang == 0) {
                    this.$set(this.$data.obj_asm, 'Lang', null);
                }
                if (this.obj_asm.DL) {
                    this.obj_asm.DIT = this.obj_asm.DL.split(",");
                } else {
                    this.obj_asm.DIT = [this.obj_asm.DI + "-" + this.obj_asm.DAI];
                }
                this.DomainChange(this.obj_asm.DIT); //console.log(value)
            },
            defineStatus() {
                if (this.obj_asm["RS"] == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            addPV() {
                this.obj_asm = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    //DN: null,
                    DI: null,
                    DAI: null,
                    DIT: null,
                    L: null,
                    N: null,
                    AI: null,
                    AT: null,
                    PURL: null,
                    AGI: "",
                    AGIT: null,
                    VT: null,
                    C: null,
                    DBL: 1,
                    DAL: 1,
                };
                this.dd_do = [];
                this.dd_lang = [];
                this.bool_obj_PvS = this.returnStatus();
                this.bool_obj_PvDBL = this.returnDisplayBeforeLoginStatus();
                this.bool_obj_PvDAL = this.returnDisplayAfterLoginStatus();

                this.bool_CV = false;
                this.bool_isAMV = true;

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_asm.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_asm.AGIT);
                    }
                }
            },
            returnStatus() {
                if (this.obj_asm["RS"] == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            returnDisplayBeforeLoginStatus() {
                if (this.obj_asm["DBL"] == 1) {
                    return true;
                } else {
                    return false;
                }
            },
            returnDisplayAfterLoginStatus() {
                if (this.obj_asm["DAL"] == 1) {
                    return true;
                } else {
                    return false;
                }
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.obj_asm[value];
                    var pattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["PV"][langKey]);
                    } else if (value == "C" && !pattern.test(this.obj_asm.C) && (this.obj_asm.VT == 0 || this.obj_asm.VT == 1 || this.obj_asm.VT == 2)) {
                        return this.getLanguage["PV"]["IURLF"];
                    }
                }

            },
            returnLastStatusForSave() {
                if (this.obj_asm["RS"] == 2) {
                    return 2;
                } else {
                    return 1;
                }
            },
            returnDisplayBeforeLoginForSave() {
                if (this.obj_asm["DBL"] == 1) {
                    return 1;
                } else {
                    return 0;
                }
            },
            returnDisplayAfterLoginForSave() {
                if (this.obj_asm["DAL"] == 1) {
                    return 1;
                } else {
                    return 0;
                }
            },
            savePV() {
                this.bool_CV = true;
                this.obj_asm['RS'] = this.returnLastStatusForSave();
                this.obj_asm['DBL'] = this.returnDisplayBeforeLoginForSave();
                this.obj_asm['DAL'] = this.returnDisplayAfterLoginForSave();
                //for (var d of this.dd_do) {
                //    if (d.id == this.obj_asm['DI']) {
                //        this.obj_asm['DN'] = d.label;
                //    }
                //}
                //if (this.obj_asm.DIT != null) {
                //    var domain = this.obj_asm.DIT.split("-");
                //    this.obj_asm.DI = domain[0];
                //    this.obj_asm.DAI = domain[1];
                //}
                //Separate DIT into Domain ID and Alternate Domain ID
                if (this.obj_asm.DIT != null) {

                    var domain = String(this.obj_asm.DIT).split("-");

                    //Used to clear cache & other function in api
                    this.obj_asm.DI = domain[0];
                    this.obj_asm.DAI = domain[1];

                    this.obj_asm.DL = this.obj_asm.DIT.join();
                }
                if (this.obj_asm.AGIT != null && this.obj_asm.AGIT.length > 0) {
                    var agi = this.obj_asm.AGIT.split("-");
                    this.obj_asm.AGI = agi[1];
                }
                if (this.obj_asm.VT == '3') {
                    this.obj_asm.C = this.editorText;
                }

                this.$v.obj_asm.$touch();
                if (!this.$v.obj_asm.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/cms/pv/s`, this.obj_asm,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getPVList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_asm"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
                //this.bool_CV = false;

                var temp_lang = "";
                if (this.obj_asm["Lang"] && this.obj_asm["Lang"].length > 0) {
                    for (var i = 0; i < this.obj_asm["Lang"].length; i++) {
                        if (i != 0) {
                            temp_lang += ",";
                        }
                        temp_lang += this.obj_asm.Lang[i];
                    }
                }
                this.obj_asm["L"] = temp_lang;
            },
            editPV(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/cms/pv/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setPV(d.D);
                            that.bool_isAMV = false;
                            if (that.obj_asm.AGI != 0) {
                                that.obj_asm.AGIT = "3-" + that.obj_asm.AGI;
                                that.AgentGroupChange(that.obj_asm.AGIT);
                            }
                            //that.obj_asm.DIT = that.obj_asm.DI + "-" + that.obj_asm.DAI;
                            //Combine Domain ID & Alternate Domain ID for "DIT"
                            //that.DomainChange(that.obj_asm.DIT);
                            that.bool_isAMV = true;

                        }
                    });
            },
            removePV(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS,
                            di: data.DI
                        };
                        this.postDataApi(`/api/cms/pv/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getPVList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },

            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getPVList();
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[4].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            HTMLEditorTextChange(value) {
                this.editorText = tinymce.get("htmluuid").getContent();;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getLanguageFilter() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`, function (d, s) {
                    if (s) {
                        that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
                    }
                });
            },
        },
        watch: {
            bool_obj_PvS(newValue) {
                if (newValue == true) {
                    this.obj_asm["RS"] = "2"
                } else {
                    this.obj_asm["RS"] = "1"
                }
            },
            bool_obj_PvDBL(newValue) {
                if (!this.bool_obj_PvDBL && !this.bool_obj_PvDAL) {
                    this.bool_obj_PvS = false;
                    this.obj_asm["RS"] = "1"
                } else {
                    if (newValue == true) {
                        this.obj_asm["DBL"] = "1"
                    } else {
                        this.obj_asm["DBL"] = "0"
                    }
                }
            },
            bool_obj_PvDAL(newValue) {
                if (!this.bool_obj_PvDBL && !this.bool_obj_PvDAL) {
                    this.bool_obj_PvS = false;
                    this.obj_asm["RS"] = "1"
                } else {
                    if (newValue == true) {
                        this.obj_asm["DAL"] = "1"
                    } else {
                        this.obj_asm["DAL"] = "0"
                    }
                }
            },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getPVList();
                this.getStatus();
                this.getLanguageFilter();
                //var that = this;
                //this.getDataApi(`/api/dd/lang/0`, function (d, s) {
                //    if (s) {
                //        //that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                //        that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
                //    }
                //});
            },
        },

    }

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/ContentManagementSystem/PromotionalVideo.vue